
<div class="w-full flex justify-center bg-[#f9f8f6] font-rubik quote-builder-sub-header-container px-3 1170-bp:px-0">
  <div class="w-full max-w-[1216px] flex flex-col quote-builder-sub-header-inner-container">
    <picture class="quote-builder-subheader-picture">
      <source
        media="(max-width: 1024px)"
        srcset="@/images/quote-builder/quote-builder-banner-mobile.png"
      />
      <img
        class="quote-builder-subheader-img"
        src="@/images/quote-builder/quote-builder-banner.png"
        alt="Banner image"
      />
    </picture>
    <div class="flex justify-between items-center px-5 quote-builder-sub-header-bottom-half">
      <div class="sub-header-text-container">
        <h1>Quote Builder</h1>
        <p>Fill in your info below.</p>
      </div>
      <button @click="home()" class="flex justify-center items-center transition-all">
        <img src="@/images/quote-builder/home.svg" alt="Return to home page">
      </button>
    </div>
  </div>
</div>
